<template>
  <div id="app">
    <keep-alive :include="['home', 'courses']">
      <router-view class="app-main"> </router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted () {

  },

}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "assets/css/style.scss";
@import "assets/css/iconfont.scss";
html,body{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app {
  width: 100vw;
  height: 100vh;
  min-width: 1200px;
  // overflow-x: auto;
}

.app-main {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.no-content {
  width: 500px;
  height: 309px;
  margin: 20px auto;
}

.no-content img {
  width: 100%;
  height: 100%;
}

.no-content div {
  width: 100%;
  color: #999;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.ellipsis-1 {
  //超过一行省略号
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.classy-menu .el-submenu__title,.el-menu--horizontal .el-menu .el-menu-item{
  font-size: 20px;
  color: #545454;
  font-weight: 400;
}

.content-container{
  width: 95%;
  max-width: 1520px;
  min-width: 1140px;
  margin: 0 auto;
}
.el-button--primary {
    background-color: #34c297;
    border-color: #34c297;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue